import React from 'react';
import styles from './ProductUpdatesLoadingSkeleton.module.scss';

export interface ProductUpdatesLoadingSkeletonProps {
  id?: string;
}

export const ProductUpdatesLoadingSkeleton: React.FC<ProductUpdatesLoadingSkeletonProps> = ({
  id,
}) => (
  <section
    id={id}
    className={styles.section}
    aria-busy="true"
    aria-label="Loading more product updates"
  >
    <div className={styles.label} />
    <div className={styles.heading} />
    <div className={styles.card} />
  </section>
);
